import { Box, Typography } from "@mui/material";
import {
    DailyHoursMap,
    computeUtilizationColor,
    formatEventsCountLabel,
    formatHoursLabel,
    sumHoursInMap,
} from "./hoursMetrics";

type CalendarToolbarProps = {
    label: string;
    view: string;
    views: Array<string>;
    onNavigate: (action: "PREV" | "NEXT" | "TODAY" | "DATE", date?: Date) => void;
    onView: (view: string) => void;
    hoursMap: DailyHoursMap;
    showTotal: boolean;
    visibleEventsCount: number;
};

const viewLabels: Record<string, string> = {
    month: "Month",
    week: "Week",
    day: "Day",
    agenda: "Agenda",
};

export const CalendarToolbar = ({
    label,
    view,
    views,
    onNavigate,
    onView,
    hoursMap,
    showTotal,
    visibleEventsCount,
}: CalendarToolbarProps) => {
    const totals = sumHoursInMap(hoursMap);
    const totalLabel = formatHoursLabel(totals);
    const totalColor = computeUtilizationColor(totals);
    const eventsCountLabel = formatEventsCountLabel(visibleEventsCount);
    const captionSx = { fontWeight: 500, fontSize: "11px" };

    return (
        <div className="rbc-toolbar">
            <span className="rbc-btn-group">
                <button type="button" onClick={() => onNavigate("TODAY")}>Today</button>
                <button type="button" onClick={() => onNavigate("PREV")}>Back</button>
                <button type="button" onClick={() => onNavigate("NEXT")}>Next</button>
            </span>
            <Box className="rbc-toolbar-label" sx={{ display: "flex", flexDirection: "column", alignItems: "center", lineHeight: 1.2 }}>
                <span>{label}</span>
                <Box>
                    {showTotal ? (
                        <Typography variant="caption" sx={{ ...captionSx, color: totalColor }}>
                            {totalLabel} |{" "}
                        </Typography>
                    ) : null}
                    <Typography variant="caption" sx={{ ...captionSx, color: "text.secondary" }}>
                        {eventsCountLabel}
                    </Typography>
                </Box>
            </Box>
            <span className="rbc-btn-group">
                {views.map((viewName) => (
                    <button
                        key={viewName}
                        type="button"
                        onClick={() => onView(viewName)}
                        className={view === viewName ? "rbc-active" : ""}
                    >
                        {viewLabels[viewName] || viewName}
                    </button>
                ))}
            </span>
        </div>
    );
};
